import React from "react";
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  footer: {
    height: 48,
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
  },
  gradientBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    height: 48,
    width: "100%",
  },
  text: {
    color: "#FFFFFF",
    fontSize: 14,
    fontWeight: 400,
    textAlign: "center",
    zIndex: 1,
  },
});

const DownloadPdfFooter: React.FC = () => {
  return (
    <View style={styles.footer}>
      <Image
        style={styles.gradientBackground}
        src="path/to/gradient-image.png"
      />
      <Text style={styles.text}>Wanda • © 2024 All Rights Reserved</Text>
    </View>
  );
};

export default DownloadPdfFooter;
